module.exports = __webpack_public_path__ + "static/img/foltest_siege.c24c641.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/foltest_siege.png
// module id = XVM5
// module chunks = 0